<template>
	<div style="width: max-content">
		<a-select
			:showArrow="true"
			mode="multiple"
			placeholder="请输入"
			allowClear
			:style="styleWidth"
			:max-tag-count="maxTagCount"
			:maxTagTextLength="maxTagLength"
			:size="size"
			:dropdown-match-select-width="false"
			:getPopupContainer="
				(triggerNode) => {
					return triggerNode.parentNode || document.body;
				}
			"
			dropdownClassName="dropdown-class"
			:dropdown-style="dropdownStyle"
			:open="open"
			v-model="selectedValues"
			:labelInValue="true"
			@focus="open = true"
			@change="handleChangeTags"
		>
			<template slot="dropdownRender">
				<div v-clickoutside="handleOpen" class="yw-selecter">
					<a-empty description="暂无数据" v-if="resource.length <= 0" />
					<div
						class="yw-select-item"
						v-for="(box, idx) in resource"
						:key="idx"
						v-else
					>
						<select-box
							v-model="box.current"
							:data="box.data"
							:level="box.level"
							:disabled="disabled"
							@on-child="pushChild"
							@on-select="selectAll"
						/>
					</div>
				</div>
			</template>
		</a-select>
	</div>
</template>
<script>
import {
	getKeyOfData,
	isArray,
	flattenTree,
	clickoutside,
	setChecked,
} from "@/utils/index.js";
import SelectBox from "./selectBox.vue";

// 清空选中
function clearTagOfData(list, Vue) {
	if (!isArray(list)) throw new Error("clearTagOfData args list invalid!");
	let i = -1;
	const len = list.length;
	while (++i < len) {
		const item = list[i];
		const itemChild = item.children || item.child;
		if (itemChild && itemChild.length) {
			clearTagOfData(itemChild, Vue);
		}
		Vue.$set(item, "check", false);
	}
}

export default {
	name: "YwMultipleCascader",
	directives: { clickoutside },
	components: {
		SelectBox,
	},
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		data: {
			type: Array,
			default: () => [],
		},
		disabled: {
			type: Boolean,
		},
		width: {
			type: [String,Number],
			default: "300",
		},
    maxTagCount: {
      type: Number,
    },
    maxTagLength:{
      type: Number,
    },
    size:{
      type: String,
      default: 'default',
    }

	},
	data() {
		return {
			resource: [],
			selectedValues: [],
			open: false,
			tempList: [],
		};
	},
	computed: {
		styleWidth() {
			return {
				width: this.width + "px",
			};
		},
		dropdownStyle() {
			return {
				"text-align": this.resource.length <= 0 ? "center" : "left",
			};
		},
	},
	watch: {
		data: {
			handler(nVal, oVal) {
				this.selectedValues = flattenTree(nVal, "value").filter(
					(it) => it.check
				);
			},
			deep: true,
			immediate: true,
		},
		"selectedValues.length": {
			handler(nVal, oVal) {
				if (nVal !== oVal) {
					const res = this.selectedValues.map((it) => it.id || it.key);
					// setChecked(this.data, res)
					this.$emit("change", res);
					// console.log('zheli', nVal)
				}
			},
		},
	},
	methods: {
		updateResource() {
			this.resource = [];
			this.resource.push({
				data: this.data,
				current: 0,
				level: 1,
			});
		},
		// 删除已选
		handleClose(id) {
			const data = getKeyOfData(this.data, "id", id);
			if (data.children && data.children.length) {
				this.selectFinalAll({ list: this.data, check: false, current: id });
			} else {
				this.$set(data, "check", false);
			}
		},
		selectAll({ level, check, cat }) {
			let index = level - 2;
			let current = index > -1 ? this.resource[index].current : 0;
			cat && (current = cat);
			this.selectFinalAll({
				check,
				current,
				list: this.data,
			});
		},
		// 推送
		pushChild(params) {
			const { item, level } = params;
			const len = this.resource.length;
			if (level <= len - 1) {
				this.resource.splice(level, len - level);
			}
			this.resource.push({
				data: item.children,
				current: 0,
				level: level + 1,
			});
			this.resource[level - 1].current = item.id;
		},
		// 全选
		selectFinalAll({ list, check = true, current = 0 }) {
			let data;
			// 无限递归
			const setAllChecked = (all, check) => {
				// console.log(all, "all");
				all.forEach((ret) => {
					if (ret.children && ret.children.length)
						setAllChecked(ret.children, check);
					this.$set(ret, "check", check);
				});
			};
			// 某一级多选
			if (current) {
				const item = getKeyOfData(list, "id", current);
				data = item.children;
			} else data = list;
			// 全部
			setAllChecked(data, check);
		},
		// 清空全部
		clearTag({ list }) {
			clearTagOfData(list, this);
		},
		// 默认选中
		decompile(Ids) {
			const deepSelect = (item) => {
				item.forEach((ret) => {
					if (ret && ret.children && ret.children.length)
						deepSelect(ret.children);
					this.$set(ret, "check", true);
				});
			};
			Ids.forEach((ret) => {
				const item = getKeyOfData(this.data, "id", ret);
				// console.log(item, "item");
				deepSelect([item]);
			});
		},
		handleOpen() {
			// this.$set(this, "resource", [this.resource[0]]);
			// this.resource.splice(1, this.resource.length - 1);
			// this.clearTag({ list: this.data });
			this.open = false;
		},
		handleChangeTags(val) {
			// const ids = val.map((it) => it.key);
			setChecked(
				this.data,
				val.map((it) => it.key)
			);
		},
	},
	created() {
		if (isArray(this.value) && this.value.length) {
			this.decompile(this.value);
		}
		this.updateResource();
	},
	mounted() {},
};
</script>
<style lang="less" scoped>
:deep(.dropdown-class) {
	min-width: auto !important;
	max-width: 1000px !important;
	max-height: 800px;
	overflow: auto;
	/* 定义滚动条样式 */
	&::-webkit-scrollbar {
		width: 5px; /* 设置滚动条宽度 */
		height: 5px;
	}

	&::-webkit-scrollbar-thumb {
		background: #167be4; /* 设置滚动条颜色 */
		border-radius: 10px; /* 设置滚动条圆角 */
	}

	&::-webkit-scrollbar-track {
		// background-color: #f5f5f5; /* 设置滚动条背景色 */
		border-radius: 10px; /* 设置滚动条背景圆角 */
	}
}
.yw-selecter {
	display: inline-flex;
	width: max-content;
	border-radius: 4px;

	.yw-select-item {
		overflow: hidden;
		min-width: 140px;
		max-width: 240px;
		box-sizing: border-box;
		padding: 6px 0;
		background: #fff;
		&:nth-child(n + 2) {
			border-left: 1px solid #e8e8e8;
		}
	}
}
</style>
